module.exports = __webpack_public_path__ + "static/img/water_256.5af5f65.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/water_256.png
// module id = riX0
// module chunks = 0